import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-material',
  templateUrl: './help-material.component.html',
  styleUrls: ['help-material.component.scss']
})
export class HelpMaterialComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
